import React, { useEffect } from 'react';
import Resizer from "react-image-file-resizer";
import { MediaUpload } from '../Constant/api';
import Webcam from "react-webcam";

export default function ImageUpload(props) {
  const {
    ImageUrl,
    setImageUrl,
  } = props;
  const fileRefSingle = React.createRef();

  const [Loading, setLoading] = React.useState(false)
  function increaseFileSize(file, targetSizeMB) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
        let data = new Uint8Array(reader.result);

        // Calculate padding needed
        const targetSize = targetSizeMB * 1024 * 1024;
        if (data.length < targetSize) {
          let padding = new Uint8Array(targetSize - data.length);
          let combined = new Uint8Array(data.length + padding.length);
          combined.set(data);
          combined.set(padding, data.length);
          resolve(new File([combined], file.name, { type: file.type }));
        } else {
          resolve(file); // already larger
        }
      };
      reader.readAsArrayBuffer(file);
    });
  }
  const MediaUploadSingleCall = async (file, i) => {
    if (!file) return;
    var fileInput = "";
    if (file) {
      fileInput = file.type;
    }
    const uri = await increaseFileSize(file, 2);

    MediaUpload(uri)
      .then(res => res.json())
      .then(data => {
        setImageUrl(data.source_url)
        setTimeout(() => {
          setLoading(false)
        }, 1000);
      })
      .catch(err => { console.log("error", err.message); })
      .finally(() => { })
  }

  



  return (
    <div>
      {Loading &&
        <div className="spinner-border"></div>
      }
      <div className="">
        <div className="row">
          {ImageUrl !== "" ?
            <div className="my-2">
              <div className=" ">
                <button type="button" onClick={() => { fileRefSingle.current.click() }}
                  className="bg-transparent border-0 p-1 "
                >
                  <img src={`${ImageUrl}`} className={" border border-dark"}
                    height="100px"
                  />
                </button>
              </div>
              <button onClick={() => {
                setImageUrl("")
              }}
                className="bg-transparent border-0 p-1 "
              ><u>Clear</u></button>
            </div>
            :
            <div className="col-3">
              <button type="button"
                onClick={() => {
                  fileRefSingle.current.click()
                }}
                className="bg-transparent border-0 p-1 "
              >
                <div className="border border-dark" style={{ padding: "10px", borderRadius: "5px" }}>
                  <i className="fa fa-camera font-size-18"></i>
                  <div style={{ fontSize: "8px" }}>Add Image</div>
                </div>
              </button>
            </div>
          }

        </div>
      </div>
      <div style={{ display: 'none' }}>
        <input type="file" accept="image/*" name="image" id="file" ref={fileRefSingle}
          capture="environment"
          onChange={(event) => {
            if (event.target.files.length !== 0) {
              setLoading(true)
              MediaUploadSingleCall(event.target.files[0])
            }
          }}
        />
      </div>


    </div>
  )
}